import { useState, useEffect } from 'react';
import { OptimizedImage } from './OptimizedImage';
import { ErrorBoundary } from './ErrorBoundary';
import './AppBanner.css';

// Créez un custom event
const bannerVisibilityEvent = new Event('bannerVisibilityChange');

const AppBannerContent = () => {
    const [isVisible, setIsVisible] = useState(true);
    const [isIOS, setIsIOS] = useState(false);

    useEffect(() => {
        // Détecte si l'utilisateur est sur iOS
        const ios = /iPad|iPhone|iPod/.test(navigator.userAgent);
        setIsIOS(ios);

        // Vérifie si l'utilisateur a déjà fermé la bannière
        const bannerClosed = localStorage.getItem('appBannerClosed');
        if (bannerClosed) {
            setIsVisible(false);
        }
    }, []);

    const handleClose = () => {
        setIsVisible(false);
        localStorage.setItem('appBannerClosed', 'true');
        // Émettre l'événement quand la bannière est fermée
        window.dispatchEvent(bannerVisibilityEvent);
    };

    const handleInstall = () => {
        // Redirection vers l'App Store ou le Play Store
        if (isIOS) {
            window.location.href = 'https://apps.apple.com/app/VOTRE_APP_ID';
        } else {
            window.location.href = 'https://play.google.com/store/apps/details?id=com.norsecoder.tarbescity';
        }
    };

    if (!isVisible) return null;

    return (
        <div className="app-banner">
            <OptimizedImage
                src="https://ltvhgfjxvqftdrzcstns.supabase.co/storage/v1/object/public/assets/icon.png"
                alt="App Icon"
                className="app-icon"
                width={48}
                height={48}
            />
            <div className="app-info">
                <h3>Hapy Community</h3>
                <p>Téléchargez notre application !</p>
            </div>
            <button onClick={handleInstall} className="install-button">
                Installer
            </button>
            <button onClick={handleClose} className="close-button">
                ✕
            </button>
        </div>
    );
};

export const AppBanner = () => (
    <ErrorBoundary>
        <AppBannerContent />
    </ErrorBoundary>
);